import { useAppStore } from '../../stores/useAppStore';
import { Header, Footer } from '../../components';

const DEFAULT_TERMS = `
# Пользовательское соглашение

## 1. Общие положения

1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между сервисом (далее — «Сервис») и пользователем (далее — «Пользователь»).

1.2. Используя Сервис, Пользователь подтверждает, что ознакомился с данным Соглашением и принимает его условия в полном объёме.

## 2. Описание услуг

2.1. Сервис предоставляет возможность покупки USDT (Tether) за рубли через СБП.

2.2. Все услуги предоставляются в соответствии с действующим законодательством.

## 3. Порядок оплаты

3.1. Оплата производится через СБП (Систему Быстрых Платежей).

3.2. После успешной оплаты USDT отправляется на указанный кошелёк TRC-20 в течение 15 минут.

3.3. Комиссия сервиса указывается при оформлении заказа.

## 4. Возврат средств

4.1. Возврат средств возможен в течение 24 часов с момента оплаты, если USDT ещё не были отправлены.

4.2. Для возврата необходимо обратиться в службу поддержки.

4.3. Возврат производится тем же способом, которым была произведена оплата.

## 5. Ответственность сторон

5.1. Сервис не несёт ответственности за:
- Указание неверного адреса кошелька Пользователем
- Технические сбои на стороне платёжных систем или блокчейна
- Колебания курса USDT после оформления заказа

5.2. Пользователь обязуется указывать корректный адрес кошелька TRC-20.

## 6. Конфиденциальность

6.1. Сервис не передаёт данные Пользователей третьим лицам.

6.2. Данные об оплате обрабатываются платёжными системами в соответствии с их политикой конфиденциальности.

## 7. Заключительные положения

7.1. Сервис оставляет за собой право изменять условия данного Соглашения.

7.2. По всем вопросам обращайтесь в службу поддержки.
`;

export function TermsPage() {
  const { settings } = useAppStore();

  // Get terms content from settings or use default
  const termsContent = settings['terms_content'] || DEFAULT_TERMS;
  const siteName = settings['site_name'] || 'RubExchange';

  // Simple markdown parser
  const parseMarkdown = (text: string) => {
    return text
      .split('\n\n')
      .map((block, index) => {
        // Headers
        if (block.startsWith('# ')) {
          return <h1 key={index}>{block.slice(2)}</h1>;
        }
        if (block.startsWith('## ')) {
          return <h2 key={index}>{block.slice(3)}</h2>;
        }
        if (block.startsWith('### ')) {
          return <h3 key={index}>{block.slice(4)}</h3>;
        }

        // Lists
        if (block.includes('\n- ')) {
          const lines = block.split('\n');
          const items = lines.filter(line => line.startsWith('- '));
          const title = lines.find(line => !line.startsWith('- '));
          return (
            <div key={index}>
              {title && <p>{title}</p>}
              <ul>
                {items.map((item, i) => (
                  <li key={i}>{item.slice(2)}</li>
                ))}
              </ul>
            </div>
          );
        }

        // Paragraph
        return <p key={index}>{block}</p>;
      });
  };

  return (
    <div className="terms-page">
      <Header />

      <main className="terms-page__main">
        <div className="terms-page__container">
          <div className="terms-page__content">
            {parseMarkdown(termsContent.replace(/TonStars/g, siteName))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
